import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgConsentApproved = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 200,
	height: 200,
	fill: "none",
	viewBox: "0 0 200 200",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-success-soft-light, #CBD9F3)",
			d: "M70.2 74.66q-.76 2.7-.92 5.52H59.2a67 67 0 0 1-5.78-6.67 7 7 0 0 1 3.4-1.8c4.7 2.3 8.04 3.27 13.39 2.95"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-success-soft-light, #CBD9F3)",
			d: "M123.22 142.28V126.4l-2.75 7.32c-5.74-2.31-11.19-5.22-16.76-8.04-2.14-1.08-3.31-1.06-5.03-1.8-.8 3.2-5.58 2.45-12.14-.22-3.01.72-5.8 2.14-8.17 4.14-2.68 2.46-5.4 10.96-7.56 17.35q-6.7-6.72-12.7-14.08c-6.7 1.75-8.38 6.78-8.9 7.41l2.15 2.63c4.88 5.9 9.49 11.3 13.56 14.78 6.24 5.35 12.25 4.48 14.74-3.23l2.21-7.2a72 72 0 0 1-.53 7.63c7.15 1.93 13.48 2.6 19.35 1.82 1.49-7.54 3.66-8.87 4.4-14.88l14.61 6.05c1.93.79 4.08.8 6.02.04a4.2 4.2 0 0 1-2.5-3.84"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-success-soft-light, #CBD9F3)",
			d: "M50.85 97.11a22.69 22.69 0 1 1-45.38 0 22.69 22.69 0 0 1 45.38 0"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-success-soft-light, #CBD9F3)",
			d: "M159.59 72.07a15.76 15.76 0 1 1-31.53 0 15.76 15.76 0 0 1 31.53 0"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-success-soft-light, #CBD9F3)",
			d: "M134.71 160.64h6.75l1.55-14.16h-1.4l-1.17 11.38a1.8 1.8 0 0 1-1.78 1.6h-2.76a1.2 1.2 0 0 0-1.19 1.18"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-success-accent, #93CB71)",
			d: "M95.56 115.83a.83.83 0 0 0 .97.64.83.83 0 0 0 .65-.96.83.83 0 0 0-.97-.64.83.83 0 0 0-.65.96"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-success-soft-light, #CBD9F3)",
			d: "M126.17 146.46h1.4a3.7 3.7 0 0 1-3.71-3.7v-26.87a3.7 3.7 0 0 1 3.7-3.7h-1.4a3.7 3.7 0 0 0-3.7 3.7v26.86a3.7 3.7 0 0 0 3.7 3.7"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-success-accent, #93CB71)",
			d: "M67.12 38.9c-1.7-3.1 1.1-4.68 1.7-2.64.22.73.53 1.23.95.6 1.12-1.63 3.83-3.33 5.01-1.85-1.13-2.87-13.5-9.55-14.82 10.42 0 0-8.85-3.16-13.12 1.17-4 4-1.21 9.2-1.21 9.2a44 44 0 0 1 10.13-6.3c4.4-1.91 6.6-1.61 7.9-1.97 2.3-.34 3.7-8.2 3.46-8.62"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-success-accent, #93CB71)",
			d: "M62.47 160.65v1.2c0 2.03.5 4.03 1.46 5.82H173.8a12 12 0 0 0 1.45-5.77v-1.25z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-success-accent, #93CB71)",
			d: "m68.3 43.7.88 2.92q-.12-1.07.36-2.02a7 7 0 0 1-1.24-.9"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-success-accent, #93CB71)",
			d: "M94.91 120.1a9 9 0 0 1-.32-2.47q-1.11-.41-2.15-.96z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "url(#consent-approved_svg__paint0_linear_4039_4513)",
			d: "M20.96 138.73a.6.6 0 0 0 .62.62.6.6 0 0 0 .63-.62.6.6 0 0 0-.63-.63.6.6 0 0 0-.62.63"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-success-accent, #93CB71)",
			d: "m57.35 67.11.96-6.36-1.55 1.11q.48 2.62.59 5.25"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-success-accent, #93CB71)",
			d: "M84.54 109.43c1.68.7 2.34 1 2.58 1.1.2-.75.57-1.28 1.1-1.39l.96-.19a4.5 4.5 0 0 1 3.63-4.14 4 4 0 0 1 3.31.6 30 30 0 0 0-4.1-6.9c-3.22-3.96-2.59 2.86-2.3 3.43a18 18 0 0 0-4.81-3.31c-2.9-1.21-4.03 1.47 1.11 6.75a9 9 0 0 0-2.89-.3c-2.87.03-2.53 2.68 1.4 4.34"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-success-accent, #93CB71)",
			d: "M96.43 106.2a3.6 3.6 0 0 0-3.54-1.01 4.1 4.1 0 0 0-3.33 3.68c.67-.14 1.1-.32 1.59-.1q2.8-.98 5.75-1.31-.17-.5-.47-1.27"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint1_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m68.62 142.94-3.68-17.92a3.7 3.7 0 0 1 3.44-4.44l22.1-1.12"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint2_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m94.73 119.25 1.13-.07a4.66 4.66 0 0 1 4.78 3.63l.42 1.85"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint3_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M109.19 160.54c-.1-.32-2.04-9.07-4.3-19"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint4_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M96.92 107.46a30 30 0 0 0-4.9-8.94c-3.21-3.97-2.6 2.86-2.3 3.42.27.55-1.48-1.92-4.8-3.3-2.9-1.21-4.04 1.47 1.1 6.74a10 10 0 0 0-2.89-.3c-2.87.05-2.53 2.7 1.4 4.35 2.2.92 2.59 1.12 2.59 1.12"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint5_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M131.51 112.18c.21-.2 3.18-2.24 4.18-2.8 1.4-.77 2.95-1.59 4.48-2.34 1.34-.66 7.45-3.62 8.8-3.99 3.64-1 3.64 0 .63 1.74a31 31 0 0 0-5.67 4.24q-1.47 1.5-2.78 3.14"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint6_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m131.84 111.94 2.91-3.76a71 71 0 0 0 3.37-5.14c2.17-3.5 2.05-1.84 1.89-.36-.12 1.07-1.7 4.93.15 4.36"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint7_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M141.51 112.19a54 54 0 0 1 5.68-3.54c1.3-.76 3.39-1.58 4.85-2.38.35-.19.39-.87-1.98-.4-.87.17-2.38.47-3.12.7"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint8_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M142.12 112.17q1.38-.76 2.84-1.35c1.32-.5 3.74-1.05 5.18-1.57.36-.13.5-.75-1.9-.71l-.94.03"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint9_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M50.45 136.44a31 31 0 0 0-4.42-4.16 25 25 0 0 0-4.73-2.7c-2.46-1.07-2.59-1.5.32-1.4q1.69.03 3.33.41c3.57.74 7.05 1.91 10.34 3.49"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint10_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M47.69 129.27c1.97.34-.21-3.04-.78-4.74-.47-1.44-.46-3.07 2.16.19a77 77 0 0 0 6.98 6.92"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint11_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M42.11 129.94a23 23 0 0 0-4.2-.48c-2.7 0-2.5.75-2.1.87 1.66.48 4.37 1.06 5.87 1.57q3.84 1.36 7.5 3.18"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint12_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m39.26 131.24-.74.06c-2.72.25-2.48.98-2.04 1.08 1.7.36 4.25.62 5.86.85q2.83.18 5.48 1.2"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint13_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M91.15 108.77q2.81-.98 5.77-1.31c3.48 9.41 1.78 12.55-4.46 9.2l2.46 3.45"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint14_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m96.98 107.57.45-.11c.77-.15 1.86 1.15 2.23 2.97.35 1.74-.08 3.3-.96 3.6"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint15_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M92.75 114.38a7 7 0 0 0 3.09 1.16"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint16_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M90.66 112.07c.26 1.29.14 3.41-1.08 3.67-.98.2-2.05-1.12-2.42-2.93-.85-4.27 2.6-5.14 3.5-.74"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint17_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m89.58 115.74 2.23-.47c.99-.2 1.46-1.84 1.1-3.65-.36-1.82-1.44-3.12-2.42-2.93l-2.29.5"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint18_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M70.75 145.12c2.18-6.41 4.92-14.84 7.62-17.32 3.62-3.32 7.96-3.89 9-4.42a5.4 5.4 0 0 0 2.23-1.74c.98-1.91 1.43-4.04 1.33-6.18"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint19_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M94.6 117.63c.05 2.15.24 5.41 6 6.92q1.63.41 3.1 1.15c6.22 3.13 12.26 6.4 18.76 8.82"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint20_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m120.47 133.74 2-5.35"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint21_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M72.13 146.48q-7.44-7.3-14-15.4a13.5 13.5 0 0 0-8.9 7.42c2.94 3.63 9.64 12.22 15.7 17.41 6.24 5.35 12.25 4.48 14.75-3.23l3.42-11.1"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint22_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M62.47 153.55v8.3a12.3 12.3 0 0 0 12.3 12.29h88.22a12.3 12.3 0 0 0 12.29-12.3v-49.98a12.3 12.3 0 0 0-12.29-12.28H92.95"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint23_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M82.46 99.58h-7.7a12.3 12.3 0 0 0-12.29 12.28v24.4"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint24_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M108.81 73.92a8.8 8.8 0 0 1-8.4 6.28h-41.2"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint25_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M109.17 63.28V34.22a8.75 8.75 0 0 0-8.76-8.76H35.1a8.73 8.73 0 0 0-8.74 8.74v37.24q0 1.57.53 3.03"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint26_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M50.85 97.11a22.68 22.68 0 1 1-45.37 0 22.68 22.68 0 0 1 45.37 0"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint27_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M159.59 72.07a15.76 15.76 0 1 1-31.53 0 15.76 15.76 0 0 1 31.53 0"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint28_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M81.38 153.09c-.2.98-3 3.77-5.39 7.63"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint29_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M72.9 173.98c-.47-2.2-.36-4.32.1-6.34"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint30_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M118.5 174.14a11.3 11.3 0 0 0-8.08-6.24l-1.06-.25"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint31_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M82.04 145.02q-.07 4.06-.66 8.07c7.14 1.93 13.48 2.6 19.34 1.82 1.5-7.53 3.67-8.87 4.4-14.86l14.62 6.03a8 8 0 0 0 5.8.13"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint32_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M127.58 112.19h-1.41a3.7 3.7 0 0 0-3.7 3.7v26.88a3.7 3.7 0 0 0 3.7 3.7h1.42"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint33_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M164.33 112.19h-36.77a3.7 3.7 0 0 0-3.7 3.7v26.88a3.7 3.7 0 0 0 3.7 3.7h36.77a3.7 3.7 0 0 0 3.7-3.7V115.9a3.7 3.7 0 0 0-3.7-3.7"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint34_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m141.61 146.48-1.2 11.38a1.8 1.8 0 0 1-1.77 1.59h-2.76a1.2 1.2 0 0 0-.84.35 1.2 1.2 0 0 0-.33.84h6.73l1.55-14.15z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint35_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M141.44 160.64h10.95l-1.36-14.16h-8.04z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint36_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M143.54 130.22a4.01 4.01 0 1 0 4-4.35 4.2 4.2 0 0 0-4 4.35"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint37_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M145.13 124.04c.64.48 1.43.72 2.23.68a2.9 2.9 0 0 0-3.24-2.78c.09.8.44 1.53 1 2.1"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint38_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M100.72 154.91a8.5 8.5 0 0 0 3.75 5.74"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint39_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M129.53 174.14a16 16 0 0 0-5.73-6.44"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint40_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m69.18 46.62-.88-2.91c1.64 1.44 5.38 3.6 6.8-4.12.46-2.5.22-3.93-.35-4.62"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint41_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M75.67 56.96c.72 4.75-.47 10.68-5.48 17.71-5.35.3-8.68-.66-13.37-2.95.95-2.58.47-6.9-.06-9.86l-7.54 5.38A67 67 0 0 0 59.81 80.8a11.3 11.3 0 0 1-9.62 7.66L38.35 73.69a8.64 8.64 0 0 1 .28-11.15 60 60 0 0 1 7-6.73"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint42_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m56.76 61.86 1.55-1.12-.96 6.37"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint43_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M56.84 71.7a7 7 0 0 0-3.4 1.8"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint44_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M113 72.27c.62-.23 1.19-.63.99-1.27-.27-.85-1.7-1.9-3.46-2.01-1.3-.1-2.03.64-.25 1.58"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint45_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M113.8 70.63a1 1 0 0 0 .4-1.27 3.4 3.4 0 0 0-2.85-1.8c-1.49-.17-1.6.6-.33 1.48"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint46_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M106.66 67.95c2.07.73 3.34-2.5 3.34-2.5"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint47_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M103.05 64.7c.73-.17 9.89-2.48 9.98-2.01.1.53-2.54 2.42-3.03 2.76 5.63.08 10.17 2.23 9.3 2.3-1.7.16-6.22-.2-8.2-.22"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint48_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M104.86 74.35q3.04-.62 6.14-.54c3.26-.2 2.38-2.88-1.08-3.3-.96-.11-1.1 1.22 1.2 2.01"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint49_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M109.94 73.05q.26-.46.17-.98"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint50_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M69.54 44.6a3 3 0 0 0 1.33 4.23c4.2 1.97 5.37 4.16 7.98 7.8 3.27 4.55 7.63 9.78 7.63 9.78 5.48-.01 10.93-.7 16.24-2.06a9.6 9.6 0 0 1 1.86 10.67 72 72 0 0 1-18.23 2.44 10.2 10.2 0 0 1-7.33-2.95 46 46 0 0 1-5.19-6.15"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint51_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M58.9 82.92q1.59 1.26 3.4 2.16c3.37 1.64 1.78 1.91.44 1.7-1.36-.22-4.43-1-4.39.02l1.08 1.47a42 42 0 0 1 3.5 6.67c1.11 3.28.22 3.33-1.55.7-3.8-5.64-6.03-7.07-7.53-8.2"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint52_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M59.43 88.27a50 50 0 0 0 5.74 5.82c1.65 1.43 1.12 1.71.78 1.63a15 15 0 0 1-3.36-1.68"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint53_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M85.14 124.1c-.57 3.83 10.27 5.9 10.36 1.9 2.67 2.97 6.96 1.1 4.73-1.56"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint54_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M98.68 123.89c-.76 3.21-5.5 2.44-12.16-.21"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint55_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M70.2 74.66q-.76 2.7-.92 5.52"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint56_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M59.96 45.45s-8.85-3.16-13.12 1.17c-3.99 4-1.21 9.2-1.21 9.2a44 44 0 0 1 10.13-6.3c4.4-1.92 6.6-1.61 7.9-1.97 2.3-.34 3.69-8.2 3.46-8.62-1.7-3.1 1.1-4.7 1.7-2.65.23.77.52 1.22.98.56 1.11-1.61 3.76-3.27 4.95-1.87-1.32-2.9-13.46-9.31-14.8 10.48"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint57_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M127.57 33.39v9.77"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint58_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M132.46 38.27h-9.77"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint59_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M176.57 86.9a1.28 1.28 0 1 1-2.55.22 1.28 1.28 0 0 1 2.54-.21"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint60_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M21.58 136.1c0-.8.3-1.36 1.29-2.67a4 4 0 0 0 1.11-2.53 2.18 2.18 0 1 0-4.33.2"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint61_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M16.6 89.74h22.34"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint62_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M22.6 84.38s-2.64 18.4 15.07 24.63"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint63_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M32.98 95.08a21 21 0 0 1-9.66 11.98"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint64_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M28.14 89.74v-2.87"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint65_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M146.5 72.71h-5.65"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint66_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m138.55 79.74 5.12-15.57 5.14 15.57"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint67_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M48.05 85.8c1 1.2 9.81-6.09 9.26-7.55"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint68_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m49.22 67.25-1.17.83"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint69_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m86.48 66.41 1.12 1.42"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint70_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M63.93 167.65h109.9"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint71_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M175.28 160.65H62.48"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint72_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M57.09 48.97c3.59-1.55 13.44 5.8 13.12 10.4 0 0 3.74-8.1 5.48-7.02"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint73_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M51.87 141.73q3.34-5.87 8.64-7.75"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint74_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M186.19 172.83a5.79 5.79 0 0 1 2.55-10.98"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint75_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M191.35 162.47a5.78 5.78 0 0 1-2.4 10.95"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint76_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m187.55 160.75 1.19 1.1-1.1 1.19"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint77_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m190.1 174.55-1.15-1.13 1.13-1.14"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#consent-approved_svg__paint78_linear_4039_4513)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M111.4 142.66c-3.88-2.23-6.03-7.28-6.03-7.28q0 2.34-.25 4.67"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint0_linear_4039_4513",
				x1: 21.582,
				x2: 21.552,
				y1: 139.165,
				y2: 138.329,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint1_linear_4039_4513",
				x1: 77.668,
				x2: 77.152,
				y1: 139.45,
				y2: 123.725,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint2_linear_4039_4513",
				x1: 97.893,
				x2: 97.779,
				y1: 123.846,
				y2: 120.17,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint3_linear_4039_4513",
				x1: 107.043,
				x2: 105.074,
				y1: 157.713,
				y2: 145.29,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint4_linear_4039_4513",
				x1: 89.078,
				x2: 88.809,
				y1: 108.574,
				y2: 99.69,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint5_linear_4039_4513",
				x1: 141.649,
				x2: 141.542,
				y1: 110.767,
				y2: 104.38,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint6_linear_4039_4513",
				x1: 135.999,
				x2: 135.652,
				y1: 110.307,
				y2: 102.962,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint7_linear_4039_4513",
				x1: 146.865,
				x2: 146.771,
				y1: 111.221,
				y2: 106.881,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint8_linear_4039_4513",
				x1: 146.231,
				x2: 146.192,
				y1: 111.625,
				y2: 109.191,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint9_linear_4039_4513",
				x1: 47.368,
				x2: 47.264,
				y1: 135.209,
				y2: 129.662,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint10_linear_4039_4513",
				x1: 51.36,
				x2: 51.161,
				y1: 130.326,
				y2: 124.425,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint11_linear_4039_4513",
				x1: 42.374,
				x2: 42.318,
				y1: 134.244,
				y2: 130.479,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint12_linear_4039_4513",
				x1: 42.016,
				x2: 41.995,
				y1: 133.949,
				y2: 131.818,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint13_linear_4039_4513",
				x1: 94.924,
				x2: 94.417,
				y1: 118.225,
				y2: 109.775,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint14_linear_4039_4513",
				x1: 98.379,
				x2: 98.01,
				y1: 113.057,
				y2: 108.669,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint15_linear_4039_4513",
				x1: 94.294,
				x2: 94.283,
				y1: 115.37,
				y2: 114.589,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint16_linear_4039_4513",
				x1: 88.902,
				x2: 88.624,
				y1: 114.777,
				y2: 110.369,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint17_linear_4039_4513",
				x1: 90.615,
				x2: 90.367,
				y1: 114.686,
				y2: 109.96,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint18_linear_4039_4513",
				x1: 80.847,
				x2: 79.804,
				y1: 140.705,
				y2: 120.874,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint19_linear_4039_4513",
				x1: 108.526,
				x2: 108.28,
				y1: 132.006,
				y2: 120.687,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint20_linear_4039_4513",
				x1: 121.475,
				x2: 121.136,
				y1: 132.942,
				y2: 129.392,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint21_linear_4039_4513",
				x1: 66.16,
				x2: 65.596,
				y1: 155.115,
				y2: 136.208,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint22_linear_4039_4513",
				x1: 118.877,
				x2: 117.694,
				y1: 163.046,
				y2: 113.082,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint23_linear_4039_4513",
				x1: 72.465,
				x2: 70.855,
				y1: 130.796,
				y2: 106.311,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint24_linear_4039_4513",
				x1: 84.007,
				x2: 83.988,
				y1: 79.264,
				y2: 75.056,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint25_linear_4039_4513",
				x1: 67.762,
				x2: 67.066,
				y1: 67.179,
				y2: 34.332,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint26_linear_4039_4513",
				x1: 28.161,
				x2: 27.073,
				y1: 113.052,
				y2: 82.669,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint27_linear_4039_4513",
				x1: 143.822,
				x2: 143.065,
				y1: 83.145,
				y2: 62.029,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint28_linear_4039_4513",
				x1: 78.685,
				x2: 78.427,
				y1: 159.581,
				y2: 154.481,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint29_linear_4039_4513",
				x1: 72.798,
				x2: 70.969,
				y1: 173.041,
				y2: 169.832,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint30_linear_4039_4513",
				x1: 113.933,
				x2: 113.823,
				y1: 173.171,
				y2: 168.829,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint31_linear_4039_4513",
				x1: 103.46,
				x2: 103.334,
				y1: 152.968,
				y2: 142.795,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint32_linear_4039_4513",
				x1: 125.025,
				x2: 119.812,
				y1: 141.377,
				y2: 119.633,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint33_linear_4039_4513",
				x1: 145.949,
				x2: 145.31,
				y1: 141.378,
				y2: 118.402,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint34_linear_4039_4513",
				x1: 138.847,
				x2: 138.267,
				y1: 158.537,
				y2: 149.075,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint35_linear_4039_4513",
				x1: 146.913,
				x2: 146.474,
				y1: 158.532,
				y2: 149.058,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint36_linear_4039_4513",
				x1: 147.551,
				x2: 147.358,
				y1: 132.716,
				y2: 127.332,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint37_linear_4039_4513",
				x1: 145.741,
				x2: 145.682,
				y1: 124.305,
				y2: 122.427,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint38_linear_4039_4513",
				x1: 102.591,
				x2: 102.381,
				y1: 159.797,
				y2: 155.959,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint39_linear_4039_4513",
				x1: 126.666,
				x2: 126.493,
				y1: 173.178,
				y2: 168.87,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint40_linear_4039_4513",
				x1: 71.82,
				x2: 71.36,
				y1: 44.89,
				y2: 37.107,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint41_linear_4039_4513",
				x1: 56.154,
				x2: 55.505,
				y1: 83.602,
				y2: 61.73,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint42_linear_4039_4513",
				x1: 57.539,
				x2: 56.924,
				y1: 66.167,
				y2: 61.986,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint43_linear_4039_4513",
				x1: 55.138,
				x2: 55.116,
				y1: 73.233,
				y2: 72.032,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint44_linear_4039_4513",
				x1: 111.624,
				x2: 111.57,
				y1: 71.778,
				y2: 69.574,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint45_linear_4039_4513",
				x1: 112.215,
				x2: 112.159,
				y1: 70.169,
				y2: 68.092,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint46_linear_4039_4513",
				x1: 108.328,
				x2: 108.279,
				y1: 67.669,
				y2: 65.923,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint47_linear_4039_4513",
				x1: 111.227,
				x2: 111.188,
				y1: 67.026,
				y2: 63.562,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint48_linear_4039_4513",
				x1: 108.948,
				x2: 108.904,
				y1: 73.783,
				y2: 71.205,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint49_linear_4039_4513",
				x1: 110.038,
				x2: 109.919,
				y1: 72.905,
				y2: 72.267,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint50_linear_4039_4513",
				x1: 87.282,
				x2: 86.568,
				y1: 72.57,
				y2: 50.56,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint51_linear_4039_4513",
				x1: 59.082,
				x2: 58.594,
				y1: 95.345,
				y2: 85.583,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint52_linear_4039_4513",
				x1: 62.87,
				x2: 62.676,
				y1: 94.621,
				y2: 89.626,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint53_linear_4039_4513",
				x1: 92.984,
				x2: 92.958,
				y1: 127.56,
				y2: 124.831,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint54_linear_4039_4513",
				x1: 92.599,
				x2: 92.588,
				y1: 125.651,
				y2: 124.098,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint55_linear_4039_4513",
				x1: 69.743,
				x2: 68.987,
				y1: 79.357,
				y2: 75.817,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint56_linear_4039_4513",
				x1: 59.717,
				x2: 59.25,
				y1: 52.229,
				y2: 36.016,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint57_linear_4039_4513",
				x1: 128.073,
				x2: 126.03,
				y1: 41.709,
				y2: 35.871,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint58_linear_4039_4513",
				x1: 127.573,
				x2: 127.57,
				y1: 39.126,
				y2: 38.456,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint59_linear_4039_4513",
				x1: 175.289,
				x2: 175.228,
				y1: 87.913,
				y2: 86.198,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint60_linear_4039_4513",
				x1: 21.809,
				x2: 21.502,
				y1: 134.989,
				y2: 130.001,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint61_linear_4039_4513",
				x1: 27.764,
				x2: 27.763,
				y1: 90.596,
				y2: 89.925,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint62_linear_4039_4513",
				x1: 30.067,
				x2: 29.111,
				y1: 105.348,
				y2: 88.887,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint63_linear_4039_4513",
				x1: 28.151,
				x2: 27.795,
				y1: 105.281,
				y2: 97.259,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint64_linear_4039_4513",
				x1: 28.642,
				x2: 28.446,
				y1: 89.317,
				y2: 87.411,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint65_linear_4039_4513",
				x1: 143.68,
				x2: 143.676,
				y1: 73.562,
				y2: 72.892,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint66_linear_4039_4513",
				x1: 143.68,
				x2: 143.114,
				y1: 77.426,
				y2: 67.013,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint67_linear_4039_4513",
				x1: 52.692,
				x2: 52.54,
				y1: 84.783,
				y2: 79.64,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint68_linear_4039_4513",
				x1: 48.635,
				x2: 48.621,
				y1: 67.956,
				y2: 67.398,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint69_linear_4039_4513",
				x1: 87.041,
				x2: 86.997,
				y1: 67.621,
				y2: 66.673,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint70_linear_4039_4513",
				x1: 118.877,
				x2: 118.876,
				y1: 168.502,
				y2: 167.832,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint71_linear_4039_4513",
				x1: 118.877,
				x2: 118.876,
				y1: 161.498,
				y2: 160.828,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint72_linear_4039_4513",
				x1: 66.387,
				x2: 66.242,
				y1: 57.786,
				y2: 50.676,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint73_linear_4039_4513",
				x1: 56.188,
				x2: 56.021,
				y1: 140.581,
				y2: 135.389,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint74_linear_4039_4513",
				x1: 185.848,
				x2: 185.35,
				y1: 171.2,
				y2: 163.87,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint75_linear_4039_4513",
				x1: 191.737,
				x2: 191.224,
				y1: 171.789,
				y2: 164.487,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint76_linear_4039_4513",
				x1: 188.145,
				x2: 188.039,
				y1: 162.699,
				y2: 161.171,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint77_linear_4039_4513",
				x1: 189.525,
				x2: 189.418,
				y1: 174.214,
				y2: 172.7,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "consent-approved_svg__paint78_linear_4039_4513",
				x1: 108.26,
				x2: 108.058,
				y1: 141.576,
				y2: 136.705,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-success-grad-from, #82B564)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-success-grad-to, #6A89C1)"
				})]
			})
		] })
	]
});
export default SvgConsentApproved;
